// DS: i3.11
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Ellipsis: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm14 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" />
      </g>
    </svg>
  </IconWrap>
);
Ellipsis.displayName = 'Ellipsis';

export default Ellipsis;
